import { connect } from 'react-redux';
import ColumnLists from './ColumnLists';

const mapStateToProps = ({ mapping, mappingFile, targetFields }) => ({
  activeDivision: mapping.activeDivision,
  sourcesGroups: mappingFile.mappingInfo[mapping.activeDivision] ? mappingFile.mappingInfo[mapping.activeDivision].subGroups : [],
  requiredFields: targetFields.requiredFields,
  mappedRequiredFields: mapping.tempMappedFields.filter(
    mappedField => targetFields.requiredFields.find(
      requiredField => ( requiredField.name === mappedField.targetField ) 
    )
  )
});

export default connect(mapStateToProps)(ColumnLists);



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/columnListsSlidingPanel/c/columnLists/ColumnListsConnector.js